import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LANDING_PAGE_ROUTE, PRODUCTS_ROUTE } from '@mwe/constants';
import { RouterLink } from '@angular/router';
import { HeaderLogoImageComponent } from './header-logo-image.component';
import { TranslateDirective } from '@ngx-translate/core';
import { AccountLogic } from '@mwe/services';

@Component({
  selector: 'mwe-header-logo',
  templateUrl: './header-logo.component.html',
  imports: [RouterLink, HeaderLogoImageComponent, TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLogoComponent {
  private readonly accountLogic = inject(AccountLogic);

  readonly title = input<string>('global.title'); // use [title] to avoid tooltip title issues
  readonly targetRoute = computed(() => {
    return this.accountLogic.isLoggedIn() ? `/${PRODUCTS_ROUTE}` : `/${LANDING_PAGE_ROUTE}`;
  });
}
